import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../../main/services';
import {Contract, RoundIndexPriceAverage, Tender} from '../../models';
import {User} from '../../../auth/models';
import {TenderContractRoundIndexPriceAverageService} from '../../services';
import {DateRange} from '../../../common/models/date-range';

@Component({
    selector: 'jft-tender-index-analysis-list',
    templateUrl: './tender-contract-dashboard-index-analysis-list.component.html',
    styleUrls: ['./tender-contract-dashboard-index-analysis-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class TenderContractDashboardIndexAnalysisListComponent implements OnInit {
    public tender: Tender;
    public contract: Contract;
    public roundIndexPriceAverage: RoundIndexPriceAverage[];
    public indexPriceAverageFiltered: RoundIndexPriceAverage[] = [];

    public dateRange: DateRange;
    public currencyId: number;
    public unitId: number;
    public dateRangeStart: string;
    public dateRangeEnd: string;

    public loading = false;

    constructor(
        public user: User,
        public service: TenderContractRoundIndexPriceAverageService,
        private route: ActivatedRoute,
        protected toast: ToastService,
    ) {
    }

    ngOnInit() {
        let data = this.route.snapshot.data;
        let parentData = this.route.parent.parent.snapshot.data;
        let parentParentData = this.route.parent.parent.parent.parent.snapshot.data;

        this.contract = parentData['contract'];
        this.tender = parentParentData['tender'];
        this.roundIndexPriceAverage = data['indexes'];

        if (this.roundIndexPriceAverage.length) {
            this.currencyId = this.roundIndexPriceAverage[0].currency.id;
            this.unitId = this.roundIndexPriceAverage[0].units.id;
            this.dateRange = this.roundIndexPriceAverage[0].dateRange;
        } else {
            this.currencyId = this.tender.currencyId;
            this.unitId = this.tender.unitsId;
            this.dateRange = null;
        }

        this.getIndexPriceAverageFiltered();
    }

    public onCurrencyChange(event) {
        this.currencyId = event;
        this.updateAll();
    }

    public onUnitChange(event) {
        this.unitId = event;
        this.updateAll();
    }

    public onDateRange(event) {
        this.dateRange = event;
        this.dateRangeStart = event.dateStart;
        this.dateRangeEnd = event.dateEnd;
        this.updateAll();
    }

    private updateAll() {
        if (!this.roundIndexPriceAverage.length) {
            return;
        }

        this.loading = true;

        let data = {
            currency_id: this.currencyId,
            units_id: this.unitId,
            date_range_id: this.dateRange.id,
            date_range_start: this.dateRangeStart,
            date_range_end: this.dateRangeEnd,
        };

        if (!data.currency_id || !data.units_id || !data.date_range_id) {
            this.toast.error('Not all fields were selected');
            return;
        }

        this.service.updateAll(this.tender.id, this.contract.id, data).subscribe((item: RoundIndexPriceAverage[]) => {
            this.toast.success(`Indexes has been updated`);
            this.roundIndexPriceAverage = item;
            this.getIndexPriceAverageFiltered();
            this.loading = false;
        }, (e) => {
            this.loading = false;
            this.toast.error(e);
        });
    }

    public addPlatts(event) {
        let data = {
            index_id: event['plattsId'],
            bate_id: event['bateId'],
            currency_id: this.currencyId,
            units_id: this.unitId,
            date_range_id: this.dateRange.id,
            date_range_start: this.dateRangeStart,
            date_range_end: this.dateRangeEnd,
        };

        if (!data.currency_id || !data.units_id || !data.date_range_id){
            this.toast.error('Not all fields were selected');
            return;
        }

        this.loading = true;

        this.service.create(this.tender.id, this.contract.id, data).subscribe((item: RoundIndexPriceAverage) => {
            this.toast.success(`Index: ${item.index.description} has been added`);
            this.loading = false;
            //this.roundIndexPriceAverage.push(item);
            this.fetchAll();
        }, (e) => {
            this.loading = false;
                this.toast.error(e);
        });
    }

    public fetchAll() {
        this.service.fetch(this.tender.id, this.contract.id).subscribe((items: RoundIndexPriceAverage[]) => {
            this.roundIndexPriceAverage = items;
            this.getIndexPriceAverageFiltered();
        }, (e) => {
                this.toast.error(e);
        });
    }

    private getIndexPriceAverageFiltered() {
        this.indexPriceAverageFiltered = [];
        this.roundIndexPriceAverage.forEach(item => {
            item['offers'] = [];

            if (item.offer) {
                item['offers'].push(item.offer);
                let existingPrice = this.indexPriceAverageFiltered.find(value => value.index.id == item.index.id);

                if (existingPrice) {
                    existingPrice['offers'].push(item.offer);
                } else {
                    this.indexPriceAverageFiltered.push(item);
                }
            } else {
                this.indexPriceAverageFiltered.push(item);
            }
        });
    }
}
